import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { toast } from '../../CommonComponents/OPL/Toast/Toast';
import { TwoFactorAuthSettingsDTO } from './useTwoFactorAuthQuery';
import { queryKeys } from './queryKeys';

interface TwoFactorAuthSettingsMutation {
  clientId: string;
  is2FAEnabled: boolean;
  email: string;
  mobilePhoneNumber: string;
}

const mutateTwoFactorAuthSettings = async ({
  clientId,
  is2FAEnabled,
  email,
  mobilePhoneNumber,
}: TwoFactorAuthSettingsMutation): Promise<TwoFactorAuthSettingsDTO> => {
  return authFetch('/Consumer/Orion2FASettings', {
    method: 'PUT',
    ...httpBodyOptions(
      {
        clientId,
        email,
        mobilePhoneNumber,
        is2FAEnabled,
      },
      true,
    ),
  });
};

interface Params {
  isInitialSetup?: boolean;
}

export const useTwoFactorAuthSettingsMutation = ({ isInitialSetup }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(mutateTwoFactorAuthSettings, {
    onSuccess: (data, { clientId }) => {
      queryClient.setQueryData(queryKeys.TwoFactorAuthSettings(clientId), data);

      if (!isInitialSetup) {
        toast.success('Two Factor Authentication settings have been saved.');
      }
    },
  });
};
